<!-- 成员账户列表组件 -->
<template>
  <div class="account-list">
    <!-- 筛选表单 -->
    <div class="filter-bar">
      <div class="filter-fields">
        <el-form :inline="true" size="small" @submit.native.prevent>
          <el-form-item label="账号">
            <el-input
              v-model="listQuery.username"
              placeholder="请输入账号"
              clearable
              @keyup.enter.native="search"
              @clear="search"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="listQuery.phone_number"
              placeholder="请输入手机号"
              clearable
              @keyup.enter.native="search"
              @clear="search"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="small" v-waves class="filter-search-btn" @click="search">搜索</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" v-waves class="filter-add-btn" @click="handleAdd">新增账户</el-button>
      </div>
    </div>

    <!-- 成员卡片列表 -->
    <div class="account-cards" v-loading="loading" element-loading-text="数据加载中">
      <template v-if="tableData.length">
        <div class="account-card" v-for="row in tableData" :key="row.id">
          <el-avatar
            :size="48"
            icon="el-icon-user-solid"
            class="account-avatar"
          ></el-avatar>
          <div class="account-info">
            <div class="account-title">
              <span class="account-name">{{ row.alias_name || row.username }}</span>
              <span class="account-role">（{{ row.role_name || '未分配角色' }}）</span>
            </div>
            <div class="account-meta">
              <span class="meta-status" :class="row.status === 1 ? 'is-disabled' : 'is-normal'">
                <i class="status-dot"></i>{{ row.status === 1 ? '停用' : '正常' }}
              </span>
              <span class="meta-item">账户 : {{ row.username || '/' }}</span>
              <span class="meta-item">手机号 : {{ row.phone_number || '/' }}</span>
              <span class="meta-item">添加时间 : {{ row.create_time || '/' }}</span>
              <span class="meta-item">最近登录 : {{ row.last_login_time || '从未登录' }}</span>
            </div>
          </div>
          <div class="account-actions">
            <el-button type="text" class="action-edit" @click="handleEdit(row)">编辑</el-button>
            <el-button
              type="text"
              class="action-delete"
              @click="handleDelete(row)"
              v-if="row.id !== 1"
            >删除</el-button>
          </div>
        </div>
      </template>
      <div v-else-if="!loading" class="empty-tip">
        <i class="el-icon-user"></i>
        <p>暂无成员账户</p>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap" v-if="listQuery.total > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.pageNumber"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listQuery.total"
      ></el-pagination>
    </div>

    <!-- 账户表单抽屉 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      direction="rtl"
      size="600px"
    >
      <div style="padding: 20px;">
        <el-form ref="form" :model="dialogForm" label-width="90px">
          <el-form-item label="账号状态:" required>
            <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%">
              <div v-for="(item, index) in statusList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="账号角色:" required>
            <el-select v-model="dialogForm.role_id" placeholder="请选择" style="width: 100%" clearable>
              <div v-for="(item, index) in authGroupList" :key="index">
                <el-option :label="item.role_name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="账号" required>
            <el-input clearable v-model="dialogForm.username" placeholder="请输入"></el-input>
          </el-form-item>
             <el-form-item label="uuid">
            <el-input
              clearable
              v-model="dialogForm.uuid"
              placeholder="自动生成"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" required>
            <el-input
              clearable
              v-model="dialogForm.password"
              placeholder="输入密码自动md5加密"
              :disabled="!!dialogForm.id"
            ></el-input>
            <el-button
              v-if="dialogForm.id"
              type="warning"
              size="mini"
              style="margin-top: 5px;"
              @click="handleResetPassword"
            >重置密码为123456</el-button>
          </el-form-item>
          <el-form-item label="昵称" required>
            <el-input clearable v-model="dialogForm.alias_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input clearable v-model="dialogForm.phone_number"></el-input>
          </el-form-item>
          <el-form-item label="异常登录" required v-if="dialogName !== '创建账号'">
            <el-input clearable v-model="dialogForm.error" placeholder="请输入次数,默认为0" type="number"></el-input>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="save">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  selectApi as selectAdmin,
  deleteApi as deleteAdmin,
  updateApi as updateAdmin,
  addApi as addAdmin
} from "@/services/admin_user/index.js";
import { selectApi as selectAuthGroup } from "@/services/admin_role/index.js";
import { selectStore } from "@/services/mall/store";
export default {
  name: "AccountList",
  props: {
    selectedRoleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        role_id: null
      },
      tableData: [],
      storeList: [],
      statusList: [
        { id: 0, name: "正常" },
        { id: 1, name: "暂停使用" }
      ],
      authGroupList: [],
      dialogName: "",
      dialogVisible: false,
      dialogForm: {
        id: null,
      },
      password: ""
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  watch: {
    selectedRoleId: {
      handler(newVal) {
        this.listQuery.role_id = newVal;
        this.listQuery.pageNumber = 1;
        this.getListData();
      },
      immediate: true
    }
  },
  created() {
    this.getGroup();
    // 监听角色更新事件
    this.$root.$on("role-list-updated", this.getGroup);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off("role-list-updated", this.getGroup);
  },
  methods: {
    /* 获取角色组 */
    getGroup() {
      selectAuthGroup().then(res => {
        if (res.code === 200) {
          this.authGroupList = res.data;
        }
      });
    },

    /* 获取列表数据 */
    async getListData() {
      this.loading = true;
      const { data, code, count } = await selectAdmin(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },

    /* 搜索按钮 */
    async search() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },

    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 所有门店数据 */
    async getStoreData() {
      const { data, code } = await selectStore({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.storeList = data;
      }
    },

    /* 新增 */
    handleAdd() {
      this.getStoreData();
      this.dialogVisible = true;
      this.dialogName = "创建账号";
      // 如果父组件有选中角色，则默认选中该角色
      this.dialogForm = {
        status: 0,
        error: 0,
        role_id: this.selectedRoleId || null
      };
      this.password = "";
    },

    /* 修改 */
    handleEdit(row) {
      this.getStoreData();
      this.dialogVisible = true;
      this.dialogName = "编辑账号";
      this.password = row.password;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.role_id ||
        !this.dialogForm.username ||
        !this.dialogForm.password ||
        !this.dialogForm.alias_name ||
        !this.dialogForm.phone_number ||
        (!this.dialogForm.error && this.dialogForm.error !== 0)
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      let formData = JSON.parse(JSON.stringify(this.dialogForm));
      if (!formData?.id) {
        addAdmin({
          ...formData,
          createID: this.userInfo.id
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
        return;
      }
      delete formData.password; // 删除不可修改字段
      updateAdmin({
        ...formData
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.dialogVisible = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteAdmin({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 重置密码 */
    handleResetPassword() {
      this.$confirm("确定要将此账号的密码重置为 123456 吗?", "重置密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 调用更新接口，密码字段传入 123456
          updateAdmin({
            id: this.dialogForm.id,
            password: "123456"
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "密码重置成功!"
                });
                // 更新表单中的密码显示
                this.dialogForm.password = "密码重置成功";
              }
            })
            .catch(err => {
              this.$message.error("密码重置失败");
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.account-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 筛选栏：新增账户 | 账号 / 手机号 | 搜索 */
.filter-bar {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;

  .filter-fields {
    display: flex;
    align-items: center;
    margin-left: 20px;

    ::v-deep .el-form {
      display: flex;
      align-items: center;
    }

    ::v-deep .el-form-item {
      margin-bottom: 0;
      margin-right: 20px;

      .el-input__inner {
        width: 180px;
      }
    }

    .filter-search-btn {
      flex-shrink: 0;
      margin-left: 4px;
    }

    .filter-add-btn {
      flex-shrink: 0;
      margin-left: 12px;
    }
  }
}

/* 成员卡片列表 */
.account-cards {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdcdc;
    border-radius: 3px;

    &:hover {
      background: #c0c0c0;
    }
  }
}

.account-card {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  margin-bottom: 12px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  transition: box-shadow 0.2s, border-color 0.2s;

  &:hover {
    border-color: #d9e4ff;
    box-shadow: 0 2px 12px rgba(61, 141, 252, 0.12);
  }

  .account-avatar {
    flex-shrink: 0;
    background: #3d8dfc;
    border-radius: 8px;
  }

  .account-info {
    flex: 1;
    min-width: 0;
    margin-left: 14px;

    .account-title {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .account-name {
        font-size: 15px;
        font-weight: 600;
        color: #1d2129;
      }

      .account-role {
        font-size: 14px;
        font-weight: 600;
        color: #1d2129;
      }
    }

    .account-meta {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 13px;
      color: #86909c;

      .meta-status {
        display: inline-flex;
        align-items: center;
        margin-right: 16px;

        .status-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 5px;
        }

        &.is-normal {
          color: #00b42a;

          .status-dot {
            background: #00b42a;
          }
        }

        &.is-disabled {
          color: #f53f3f;

          .status-dot {
            background: #f53f3f;
          }
        }
      }

      .meta-item {
        margin-right: 20px;
      }
    }
  }

  .account-actions {
    flex-shrink: 0;
    margin-left: 16px;

    .action-edit {
      color: #3d8dfc;
      padding: 0;
    }

    .action-delete {
      color: #f53f3f;
      padding: 0;
      margin-left: 16px;
    }
  }
}

/* 空状态 */
.empty-tip {
  text-align: center;
  padding: 60px 0;
  color: #c0c4cc;

  i {
    font-size: 48px;
  }

  p {
    margin-top: 10px;
    font-size: 14px;
  }
}

/* 分页 */
.pagination-wrap {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}
</style>
